import React from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Grid,
  Typography,
} from "@material-ui/core";
import { translate as t } from "../../../../../../../../../infrastructure/translate/localization";
import useStyles, { CustomRadio } from "./styles";

export default function KeepRecoverRadioGroup({ title, onChange, value }) {
  const { container, radioContainer } = useStyles();

  return (
    <FormControl component="fieldset" className={container}>
      <Typography variant="body1" align="left">
        {title}
      </Typography>
      <RadioGroup value={value} onChange={onChange}>
        <Grid container item xs={12}>
          <Grid item container xs={6} className={radioContainer}>
            <FormControlLabel
              value="recover"
              control={<CustomRadio disableRipple />}
              label={`${t("actions.recover")} ${t("common-messages.balance")}`}
            />
          </Grid>
          <Grid item container xs={6}>
            <FormControlLabel
              value="keep"
              control={<CustomRadio disableRipple />}
              label={`${t("actions.keep")} ${t("common-messages.balance")}`}
            />
          </Grid>
        </Grid>
      </RadioGroup>
    </FormControl>
  );
}

KeepRecoverRadioGroup.defaultProps = {
  value: "keep",
};

KeepRecoverRadioGroup.propTypes = {
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};
